import { initExpiryCountdown } from './expiry_countdown';

export const initTwoFactorCountdown = () => initExpiryCountdown({
  timeElementId: 'two-factor-countdown',
  resendElementId: 'two-factor-resend',
});
